import { onViewChange, allToTallest, queryAll } from '@/resources/assets/js/modules/utils';


class Products {
  constructor(root) {
    this.root = root;
    this.products = [...this.root.querySelectorAll('.products')];

    this.#resizeProductsTitles();
    this.#updateProductsPage();

    onViewChange(this.#resizeProductsTitles.bind(this));
  }

  #resizeProductsTitles() {
    setTimeout(() => {
      const productsTitles = [...this.root.querySelectorAll('.product-body h2')];
      if (productsTitles.length) {
        allToTallest(productsTitles);
      }
    }, 100);
  }

  #updateProductsPage() {
    const wooProductsPage = document.querySelector('.post-type-archive-product');
    const currentUrl = window.location.href;
    const sector = document.cookie.includes('sector=trade') ? 'trade' : 'homeowners';

    if (currentUrl.includes(`/product-sector-${sector}/`)) return;

    if (wooProductsPage) {
      if (document.cookie.includes('sector=homeowners')) {
        window.location.href = `${globals.siteRoot}products/swoof/product-sector-homeowners/`;
      }

      // if sector cookie is trade, show trade products
      if (document.cookie.includes('sector=trade')) {
        window.location.href = `${globals.siteRoot}products/swoof/product-sector-trade/`;
      }
    }
  }
}

class SingleProduct {
  constructor(root) {
    this.root = root;
    this.description = this.root.querySelector('.wc-moreInformation > div');
    this.seeMore = this.root.querySelector('.wc-moreInformation > a');
    this.#bindEvents();
  }

  #bindEvents() {
    this.seeMore.addEventListener('click', this.#toggleContent.bind(this));
  }

  #toggleContent(e) {
    e.preventDefault();
    e.target.closest('a').classList.toggle('isActive');
    this.description.classList.toggle('isActive');
  }
}

[...document.querySelectorAll('.products')].forEach(item => {
  new Products(item);
});

[...document.querySelectorAll('.wc_single_product-main')].forEach(node => new SingleProduct(node));

(function () {
      var GATEWAY_ID = 'yith-paypal-ec';  // seen in your logs
      var CLS = 'paypal-ready';
      var DEBUG = true;
      function log(){ if (DEBUG && window.console) console.log.apply(console, arguments); }
      function isYithChosen(){
        var el = document.querySelector('input[name="payment_method"]:checked');
        return !!(el && el.value === GATEWAY_ID);
      }
      function markReady(src){
        if (!isYithChosen()) return;
        if (!document.body.classList.contains(CLS)) {
          document.body.classList.add(CLS);
          log('[YITH EC] marked ready via', src);
        }
      }

      // Fallback: if URL happens to contain approval params
      try {
        var p = new URLSearchParams(location.search);
        if (p.has('token') || p.has('PayerID') || p.has('payerId') || p.has('payer_id')) markReady('url');
      } catch(e){}

      // Fallback: hidden fields (some builds still add them)
      function scanHidden(){
        var form = document.querySelector('form.checkout');
        if (!form) return;
        var hit = false;
        form.querySelectorAll('input[type="hidden"]').forEach(function(el){
          var n = (el.name || '').toLowerCase();
          var v = (el.value || '').trim();
          if (!v) return;
          if (/(^|_)(payer|payerid|payer_id|token)(_|$)/.test(n)) hit = true;
          if (/paypal/.test(n) && /(token|payer)/.test(n)) hit = true;
          if (/yith/.test(n) && /paypal/.test(n) && /(token|payer)/.test(n)) hit = true;
          if (n.includes('token') && /^EC-[A-Z0-9-]+$/i.test(v)) hit = true;
        });
        if (hit) markReady('hidden-fields');
      }

      // Authoritative: watch Woo/jQuery AJAX and look for YITH EC endpoints
      jQuery(function(){
        // 1) On any successful AJAX call
        jQuery(document).ajaxSuccess(function(_evt, xhr, settings){
          var url = settings && settings.url ? settings.url.toString() : '';
          var body = xhr && xhr.responseText || '';

          // Most YITH EC flows call wc-ajax endpoints that contain "yith", "paypal" or "ec"
          var looksLikeYith =
              /wc-ajax/i.test(url) &&
              /(yith|paypal|express|ec)/i.test(url) &&
              /(set|get|do|confirm|complete|return|review)/i.test(url);

          // Some builds return JSON with useful keys
          var signs = /(payer|payer_id|payerid|token|express)/i.test(url) ||
                      /(payer|payer_id|payerid|EC-|express)/i.test(body);

          if (looksLikeYith || signs) {
            log('[YITH EC] ajaxSuccess matched', {url:url});
            markReady('ajaxSuccess');
          }
        });

        // 2) Also watch for checkout fragment refresh immediately after popup closes
        jQuery(document.body).on('updated_checkout wc_fragments_refreshed', function(){
          scanHidden();
        });

        // 3) Mutation observer as a final safety (popup adds/removes iframes then triggers AJAX)
        new MutationObserver(function(){ scanHidden(); })
          .observe(document.body, { childList:true, subtree:true });

        // Initial checks
        scanHidden();
      });

      // If user switches away from YITH, remove the class
      jQuery(document).on('change', 'input[name="payment_method"]', function(){
        if (!isYithChosen()) document.body.classList.remove(CLS);
      });
    })();

    jQuery(function () {
      if (!document.body.classList.contains('woocommerce-checkout')) return;

      jQuery(document).on('click', '.ExpressDisconnect', function (e) {
        e.preventDefault();

        // Immediate UI reset
        document.body.classList.remove('paypal-ready');

        // Switch away from YITH so the page shows other methods while reloading
        var card = document.querySelector('input[name="payment_method"][value^="stripe"]')
                || document.querySelector('input[name="payment_method"]:not([value*="paypal"])');
        if (card) {
          card.checked = true;
          jQuery(card).trigger('change');
        }

        // Hit our AJAX to clear YITH/PayPal EC session flags, then reload cleanly
        jQuery.post(wc_checkout_params.ajax_url, { action: 'fa_reset_yith_ec' })
          .always(function () {
            // Drop any PayPal approval params from the URL (if present), then reload
            try {
              var url = new URL(window.location.href);
              ['token','PayerID','payerId','payer_id'].forEach(function(k){ url.searchParams.delete(k); });
              window.location.href = url.toString();
            } catch (e) {
              window.location.reload();
            }
          });
      });
    });
